/* eslint-disable react/prop-types */
import { colors, strCode } from "../../../consts";
import { t } from "../../../services";

import {
  FlexContainers,
  GradientLoader,
  IconButton,
  SVG,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";
import { HardwareIconContainer } from "./styled";

export const MercuryHardwareTableColumns = [
  {
    Header: strCode.MAC_ADDRESS_TITLE,
    accessor: "hubId",
    Cell: ({ cell, cellWidth3, isLoading, searchedText }) => {
      return (
        <CellWrapper width={`${cellWidth3}px`}>
          <WrapperContainer Container={FlexContainers.FlexRowStart} gap={16}>
            {isLoading ? (
              <GradientLoader width={40} height={40} animationDuration={40} borderRadius={8} />
            ) : (
              <HardwareIconContainer Container={FlexContainers.FlexRowCenter}>
                <SVG.MercuryHardwareIcon />
              </HardwareIconContainer>
            )}

            <TextOverflowWrapper
              style={{ color: colors.RAISIN_100, fontWeight: 600 }}
              highlightedText={searchedText}>
              {isLoading ? (
                <GradientLoader width={"250px"} height={24} animationDuration={40} />
              ) : (
                cell.value
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.LOCATION_TITLE,
    accessor: "locationId",
    Cell: ({ cell, cellWidth5, isLoading, callbackFn2: getLocations }) => {
      const locations = getLocations();
      const locationName =
        locations.find((location) => location.id === cell.value)?.locationName ?? null;

      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <TextOverflowWrapper
            style={{ color: locationName ? colors.RAISIN_70 : colors.RAISIN_50 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth5} height={24} animationDuration={40} />
            ) : (
              locationName ?? t(strCode.UNASSIGNED_INFO)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.MARKET_TITLE,
    accessor: "market",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
            ) : cell.value?.length ? (
              cell.value
            ) : (
              t(strCode.NA_INFO)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: "",
    id: "control",
    accessor: "locationId",
    Cell: ({ cell, isLoading, callbackFn1: onAssign }) => {
      const originalRow = cell.row.original;

      return (
        <CellWrapper width={"100%"}>
          {!isLoading && (
            <WrapperContainer Container={FlexContainers.FlexRowCenter} width={"100%"}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onAssign(originalRow);
                }}
                tooltipLabel={t(strCode.ASSIGN_BTN)}>
                <SVG.EditIcon />
              </IconButton>
            </WrapperContainer>
          )}
        </CellWrapper>
      );
    }
  }
];
